import ajax from '@app/js/modules/ajax'
import { defaultsDeep } from 'lodash'
import { Models } from '../../../types'
import Crud from './crud'

const crud = new Crud<Models.Organigrama>('organigrama/saved')

crud
  .mapMethod('create', 'store')
  .addAction('load', (context, payload) => {
    return ajax.post('/organigrama/saved/load', payload)
  })

export default {
  namespaced: true,
  ...crud.export()
}
